import React from 'react';

import { Text, Row, Icon, LoadingOutlined, Column } from 'farmhub-ui-core';

import { PartnerNote } from 'api';
import { theme } from 'styled';
import { formatDate, ICONS } from 'utils';

import PartnerNoteEditor from './PartnerNoteEditor';
import { PartnerNoteTitleItemWrapper, Color } from './styles';

type PartnerNoteTitleItemProps = {
  data: PartnerNote;
  activeFormID: string | undefined;
  onCreateDescription: () => void;
  onCopyNote: () => void;
  onDeleteNote: (val: any) => Promise<void>;
  onUpdateNote: (val: any) => Promise<void>;
  onActiveFormID: (val: string | undefined) => void;
};

const PartnerNoteTitleItem = ({
  data,
  onCreateDescription,
  onDeleteNote,
  onCopyNote,
  onUpdateNote,
  onActiveFormID,
  activeFormID,
}: PartnerNoteTitleItemProps): JSX.Element => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [isEditMode, setIsEditMode] = React.useState(false);

  const handleUpdateNote = async (val: any) => {
    setIsLoading(true);
    await onUpdateNote(val);
    handleCancelEditMode();
    setIsLoading(false);
  };

  const handleDeleteNote = async () => {
    setIsLoading(true);
    await onDeleteNote(data);
    handleCancelEditMode();
    setIsLoading(false);
  };

  const handleShowEditMode = () => {
    setIsEditMode(true);
    onActiveFormID(data.id);
  };

  const handleCancelEditMode = () => {
    setIsEditMode(false);
    onActiveFormID(undefined);
  };

  if (isEditMode && activeFormID == data.id) {
    return (
      <PartnerNoteEditor
        color={data.color}
        title={data.title}
        onCancel={handleCancelEditMode}
        onSubmit={handleUpdateNote}
      />
    );
  }

  return (
    <PartnerNoteTitleItemWrapper>
      <Row alignItems="flex-start" styles={{ gap: 8 }}>
        <Row styles={{ paddingTop: '4px' }} width="fit-content">
          <Color color={data.color} />
        </Row>

        <Column>
          <Text
            color="primary"
            styles={{ cursor: 'pointer', width: '100%' }}
            weight="bold"
            onClick={handleShowEditMode}
          >
            {data.title}
          </Text>
          {data?.updatedAt && (
            <Text size="tiny" styles={{ fontStyle: 'italic' }}>
              {formatDate(data?.updatedAt, 'DD/MM/YYYY HH:mm')}
            </Text>
          )}
        </Column>
      </Row>
      <Row
        className="note-title-action"
        styles={{ gap: 12, marginTop: '4px' }}
        width="fit-content"
      >
        <Icon
          styles={{ cursor: 'pointer' }}
          svgProps={{
            icon: ICONS.PLUS,
            width: '12px',
            height: '12px',
            color: theme.colors.text.primary,
          }}
          tooltip="Thêm mới"
          onClick={onCreateDescription}
        />
        <Icon
          styles={{ cursor: 'pointer' }}
          svgProps={{
            icon: ICONS.COPY,
            width: '13px',
            height: '13px',
            color: theme.colors.text.primary,
          }}
          tooltip="Sao chép"
          onClick={onCopyNote}
        />
        {isLoading ? (
          <LoadingOutlined spin style={{ fontSize: 14 }} />
        ) : (
          <Icon
            styles={{ cursor: 'pointer' }}
            svgProps={{
              icon: ICONS.CLOSE,
              width: '12px',
              height: '12px',
              color: theme.colors.text.primary,
            }}
            tooltip="Xóa"
            onClick={handleDeleteNote}
          />
        )}
      </Row>
    </PartnerNoteTitleItemWrapper>
  );
};

export default PartnerNoteTitleItem;
